import { useMemo } from "react";

import usePolledQuery from "apollo/usePolledQuery";
import { PollingIntervalGroups } from "apollo/constants";

import { GET_CHANGE_FAILURE_RATE_AVERAGE } from "./gql";

type UseGetChangeFailureRateAverageProps = {
  startTimeUnix: number;
  endTimeUnix: number;
};

const useGetChangeFailureRateAverage = ({
  startTimeUnix,
  endTimeUnix,
}: UseGetChangeFailureRateAverageProps) => {
  const { data, loading, error, refetch, networkStatus, previousData } = usePolledQuery(
    GET_CHANGE_FAILURE_RATE_AVERAGE,
    {
      variables: { input: { startTime: startTimeUnix, endTime: endTimeUnix } },
      pollingGroup: PollingIntervalGroups.Dashboard,
    }
  );

  // Returns raw ratio (0–1), not percentage; undefined when no data yet
  const rate = useMemo(() => {
    return (
      data?.metricsRange?.changeFailureRateValue?.[0]?.value ??
      previousData?.metricsRange?.changeFailureRateValue?.[0]?.value
    );
  }, [data, previousData]);

  return {
    rate,
    loading,
    error,
    refetch,
    networkStatus,
  };
};

export default useGetChangeFailureRateAverage;
